import React from 'react';
import classes from './Input.module.css';

const Input = (props) => {

    let inputElement= null;
    let inputClasses = [classes.InputElement];

    if(props.inValid && props.isTouched && props.shouldValidate){
        inputClasses.push(classes.Invalid);
    }

    switch(props.elementType){
        case 'input':
            inputElement = <input 
                className={inputClasses.join(' ')} 
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed}/>;
            break;
        case 'textarea':
            inputElement = <textarea 
                className={inputClasses.join(' ')} 
                {...props.elementConfig}
                value={props.value}/>;
            break;
        case 'email':
            break;
        default:
            break;
    }

    return (
        <div className={classes.Input}>
            <label className={classes.LabelDecoration}>{props.label}</label>
            {inputElement}
        </div>
    );
}

export default Input;